var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.baseball ? _c('v-tabs', {
    staticClass: "sub-staff-tab",
    attrs: {
      "grow": "",
      "hide-slider": ""
    }
  }, [_c('v-tab', {
    attrs: {
      "to": "/center/HyunNamsu"
    }
  }, [_vm._v("현남수 총감독")]), _c('v-tab', {
    attrs: {
      "to": "/center/ParkSanghyuk"
    }
  }, [_vm._v("박상혁 감독")])], 1) : _c('v-tabs', {
    staticClass: "sub-staff-tab",
    attrs: {
      "grow": "",
      "hide-slider": ""
    }
  }, [_c('v-tab', {
    attrs: {
      "to": "/center/KimHyunwoong"
    }
  }, [_vm._v("김현웅 코치")]), _c('v-tab', {
    attrs: {
      "to": "/center/JeongDahoon"
    }
  }, [_vm._v("정다훈 코치")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }